// ** MUI Imports
import Grid from '@mui/material/Grid'

// ** Type Import
import { LayoutProps } from 'src/@core/layouts/types'

// ** Menu Components
import HorizontalNavItems from './HorizontalNavItems'

// ** Types
interface Props {
  settings: LayoutProps['settings']
  horizontalNavItems: NonNullable<NonNullable<LayoutProps['horizontalLayoutProps']>['navMenu']>['navItems']
}

const Navigation = (props: Props) => {
  const { isTabletMenuOpen, isMobileMenuOpen } = props.settings

  return (
    <Grid
      className='menu-content'
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        transition: 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        opacity: isTabletMenuOpen || isMobileMenuOpen ? 1 : 0,
        overflow: 'hidden',
        pointerEvents: isTabletMenuOpen || isMobileMenuOpen ? 'auto' : 'none',
        '& > *': {
          '&:not(:last-child)': { mr: 1 }
        }
      }}
    >
      <HorizontalNavItems {...props} />
    </Grid>
  )
}

export default Navigation
